<template>
  <Transition name="fade-slow" mode="out-in" appear>
    <Button
      v-if="variant === 'clear' && !hide"
      :label="$t('components.buttons.clear_selection')"
      variant="tertiary"
      type="color"
      :size="isMobile ? 'lg' : 'xs'"
      :disabled="disabled"
      @click.stop="$emit('clear')"
    />
    <div
      v-else-if="variant === 'add-file' && !hide"
      class="flex flex-col items-center"
    >
      <FilesActionsMenu
        :buildingId="buildingId"
        @goToStep="$emit('goToStep', $event)"
      >
        <Button
          :label="$t('components.buttons.link_file')"
          variant="tertiary"
          type="color"
          :size="isMobile ? 'lg' : 'xs'"
          :disabled="disabled"
        >
          <template #start>
            <Icon name="plus" />
          </template>
          <template v-if="!maxSmall" #end>
            <Icon
              name="chevron-down"
              class="group-data-[state=open]/dropdown:-rotate-180 transition-transform duration-200"
            />
          </template>
        </Button>
      </FilesActionsMenu>
    </div>
    <div v-else-if="variant === 'add-task' && !hide">
      <Button
        :label="$t('components.buttons.create_task')"
        variant="tertiary"
        type="color"
        :size="isMobile ? 'lg' : 'xs'"
      >
        <template #start>
          <Icon name="plus" />
        </template>
      </Button>
    </div>
    <div
      v-else-if="variant === 'add-qr-code' && !hide"
      class="flex items-center button-tertiary-color-fg"
    >
      <Button
        :label="$t('components.passport.qr_codes.add_code')"
        variant="link"
        type="light"
        :size="isMobile ? 'md' : 'sm'"
        @click="$emit('goToStep', 'scan')"
      />
    </div>
    <Button
      v-else-if="!hide"
      :label="label"
      variant="tertiary"
      type="color"
      :size="isMobile ? 'lg' : 'xs'"
      :disabled="disabled"
      @click.stop="$emit(event)"
    >
      <template v-if="icon" #start>
        <Icon :name="icon" />
      </template>
    </Button>
  </Transition>
</template>

<script setup>
import { Button } from "@/SharedComponents/Buttons";
import { Icon } from "@/SharedComponents/Icon";
import { ActionsMenu as FilesActionsMenu } from "@/SharedComponents/Passport/Steps/Files";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["clear", "goToStep", "click"]);

defineProps({
  variant: { type: String, required: false },
  label: { type: String, required: false },
  icon: { type: String, required: false },
  event: { type: String, default: "click" },
  disabled: { type: Boolean, required: false },
  hide: { type: Boolean, default: false },
  buildingId: { type: String, required: true },
  isMobile: { type: Boolean, required: false },
});
</script>
